import { Popup, PopupArrow } from '@cian/components';
import { mergeStyles } from '@cian/utils';
import { path } from 'ramda';
import * as React from 'react';

import { INewbuildingInfo } from '../../../../api/newbuildings';
import { Button } from '../../../../common/components/button';
import { DynamicPhoneButton } from '../../../../common/components/DynamicButtonPhone/DynamicButtonPhone';
import { IResultsState, IUserGADataLayerData, TUser } from '../../../../common/state/app_state';
import { IJsonQuery, IJsonQueryGeo } from '../../../../json_query';
import { trackDevelopersContactsPopupOpened, trackPhoneButtonClickedFromDeveloperContacts } from './tracking';

import * as styles from './DeveloperContacts.css';

export interface IDevelopersContactsProps {
  newbuildingInfo: INewbuildingInfo | null;
  geo: IJsonQueryGeo | undefined;
  userGADataLayerData: IUserGADataLayerData;
  jsonQuery: IJsonQuery;
  user: TUser;
  results: IResultsState;
}

export interface IDevelopersContactsState {
  isPopupVisible: boolean;
}

export class DevelopersContacts extends React.PureComponent<IDevelopersContactsProps, IDevelopersContactsState> {
  public state = {
    isPopupVisible: false,
  };

  public render() {
    const contacts = this.props.newbuildingInfo && this.props.newbuildingInfo.contacts;
    const { isPopupVisible } = this.state;

    if (!contacts) {
      return null;
    }

    if (contacts.length === 1) {
      const contact = contacts[0];
      const blockId: number | null | undefined = path(['newbuildingDynamicCalltracking', 'siteBlockId'], contact);

      return <DynamicPhoneButton blockId={blockId} defaultPhone={contact.phone} onClick={this.trackPhoneOpened} />;
    }

    return (
      <div className={styles['wrapper']}>
        <Button
          {...mergeStyles(styles['toggle'], isPopupVisible && styles['active'])}
          onClick={this.togglePopup}
          theme="primary"
        >
          Показать телефоны
        </Button>
        {isPopupVisible && (
          <Popup arrow={PopupArrow.RIGHT} containerStyle={styles['contacts']}>
            {contacts.map((contact, index) => {
              const { avatarUrl, name } = contact;
              const blockId: number | null | undefined = path(
                ['newbuildingDynamicCalltracking', 'siteBlockId'],
                contact,
              );

              return (
                <div key={index} className={styles['contact']}>
                  {avatarUrl && (
                    <div className={styles['contact-avatar']}>
                      <img width="42" height="42" src={avatarUrl} />
                    </div>
                  )}
                  <div className={styles['contact-info']}>
                    <strong className={styles['contact-name']}>{name}</strong>
                    <DynamicPhoneButton
                      blockId={blockId}
                      defaultPhone={contact.phone}
                      onClick={this.trackPhoneOpened}
                      phoneAsLabel
                    />
                  </div>
                </div>
              );
            })}
          </Popup>
        )}
      </div>
    );
  }

  private trackPhoneOpened = (phone: string) => {
    const { newbuildingInfo, geo, userGADataLayerData, jsonQuery, user, results } = this.props;

    trackPhoneButtonClickedFromDeveloperContacts(
      newbuildingInfo,
      geo,
      userGADataLayerData,
      jsonQuery,
      user,
      results,
      phone,
    );
  };

  private togglePopup = () => {
    const isPopupVisible = !this.state.isPopupVisible;
    const { newbuildingInfo } = this.props;

    if (isPopupVisible) {
      trackDevelopersContactsPopupOpened(newbuildingInfo);
    }

    this.setState({ isPopupVisible });
  };
}
